import { render } from "./HeadUp.vue?vue&type=template&id=4469b1ab&scoped=true"
import script from "./HeadUp.vue?vue&type=script&lang=js"
export * from "./HeadUp.vue?vue&type=script&lang=js"

import "./HeadUp.vue?vue&type=style&index=0&id=4469b1ab&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4469b1ab"]])

export default __exports__